import type { ReactNode } from 'react';
import { PageHeader } from '../page-header/PageHeader';
import { PageHeaderDescription } from '../page-header/PageHeaderDescription';
import { PageHeaderTitle } from '../page-header/PageHeaderTitle';
import { cn } from '../utils';

export interface SitePageProps {
  title: ReactNode;
  description?: ReactNode;
  breadcrumbs?: ReactNode;
  backButton?: ReactNode;
  children?: ReactNode;
  className?: string;
}

export function SitePage({ title, description, breadcrumbs, backButton, children, className }: SitePageProps) {
  return (
    <div className={cn('flex flex-1 flex-col pt-3 md:pt-6', className)}>
      <PageHeader className="mb-6 px-2.5">
        {breadcrumbs}
        {backButton}
        <PageHeaderTitle>{title}</PageHeaderTitle>
        {description != null ? <PageHeaderDescription>{description}</PageHeaderDescription> : null}
      </PageHeader>
      {children}
    </div>
  );
}
